const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const {shrinkQuad} = require("../util/QuadUtil");
const {getRootFontSize} = require("../util/ContainerSize");
const MeasuredEl = require("../view/MeasuredEl");
const ContainerDims = require("../view/ContainerDims");
const styles = require("./styles/Quad.css");

// Returns border widths as 0-1 values giving proportion of total size.
const computeBorderWidths = function(props, measure) {
	const {borderWidths, borderUnits} = props;
	const {width, height, containerDims} = measure;
	return borderWidths.map((x, i) => {
		const size = i % 2 ? width : height;
		if (borderUnits === "px") {
			return x / size;
		} else if (borderUnits === "rem") {
			return (x * getRootFontSize(containerDims)) / size;
		} else if (borderUnits === "%") {
			return x / 100;
		}
	});
};

// Render paths drawing the quad borders, one path per direction. A border
// width of 0 means no path.
const computeBorderEls = function(qv, borderClass, borderWidths) {
	// Vertically shrunken quad only
	const vsqv = shrinkQuad(qv, borderWidths[0], 0, borderWidths[2], 0);
	// Horizontally shrunken quad only
	const hsqv = shrinkQuad(qv, 0, borderWidths[1], 0, borderWidths[3]);
	const els = [];
	if (borderWidths[0]) {
		const d =
			`M${qv[0]},${qv[1]}L${qv[2]},${qv[3]}` +
			`L${vsqv[2]},${vsqv[3]}L${vsqv[0]},${vsqv[1]}z`;
		els.push(<path key="top" className={borderClass} d={d} />);
	}
	if (borderWidths[1]) {
		const d =
			`M${qv[4]},${qv[5]}L${qv[2]},${qv[3]}` +
			`L${hsqv[2]},${hsqv[3]}L${hsqv[4]},${hsqv[5]}z`;
		els.push(<path key="right" className={borderClass} d={d} />);
	}
	if (borderWidths[2]) {
		const d =
			`M${qv[4]},${qv[5]}L${qv[6]},${qv[7]}` +
			`L${vsqv[6]},${vsqv[7]}L${vsqv[4]},${vsqv[5]}z`;
		els.push(<path key="bottom" className={borderClass} d={d} />);
	}
	if (borderWidths[3]) {
		const d =
			`M${qv[0]},${qv[1]}L${qv[6]},${qv[7]}` +
			`L${hsqv[6]},${hsqv[7]}L${hsqv[0]},${hsqv[1]}z`;
		els.push(<path key="left" className={borderClass} d={d} />);
	}
	return els;
};

// Ugly: some quads need to overflow their container. We compute the needed
// overflow, then bump the svg size up by that much while ensuring the
// positioning stays the same. Still, it causes some distortion, enough
// that things look noticeably better when we do each direction separately.
const computeSVGOverflow = function(qv, width, height, offset, shadowBlur) {
	const qvX = qv.filter((a, i) => i % 2 === 0);
	const qvY = qv.filter((a, i) => i % 2 === 1);
	let topOverflow = Math.ceil(Math.max(0, -Math.min(...qvY)));
	let rightOverflow = Math.ceil(Math.max(0, Math.max(...qvX) - width));
	let bottomOverflow = Math.ceil(Math.max(0, Math.max(...qvY) - height));
	let leftOverflow = Math.ceil(Math.max(0, -Math.min(...qvX)));
	if (shadowBlur) {
		//If it has blurry shadows, allow an extra offset for each dimension
		topOverflow += offset;
		rightOverflow += offset;
		bottomOverflow += offset;
		leftOverflow += offset;
	}
	const svgStyle = {
		position: "absolute",
		left: (-leftOverflow * 100) / width + "%",
		top: (-topOverflow * 100) / height + "%",
		width:
			((width + leftOverflow + rightOverflow + offset) * 100) / width + "%",
		height:
			((height + topOverflow + bottomOverflow + offset) * 100) / height + "%",
	};
	const svgViewBox = [
		-leftOverflow,
		-topOverflow,
		width + leftOverflow + rightOverflow + offset,
		height + topOverflow + bottomOverflow + offset,
	].join(" ");
	return {svgStyle, svgViewBox};
};

const defaultProps = {
	backgroundClass: styles.background,
	borderClass: styles.border,
	borderWidths: [0, 0, 0, 0],
	borderUnits: "%",
};
module.exports = createReactClass({
	displayName: "Quad",

	propTypes: {
		quad: PT.func.isRequired,
		backgroundClass: PT.string.isRequired,
		borderClass: PT.string.isRequired,
		svgClass: PT.string,
		backgroundColor: PT.string,
		borderUnits: PT.oneOf(["%", "px", "rem"]).isRequired,
		// Array of four 0-1 values, giving trbl border widths (same order as CSS).
		borderWidths: PT.arrayOf(PT.number).isRequired,
		// Only used as part of HOC rendering.
		containerIgnoresBorder: PT.bool,
		useBoundingClientRect: PT.bool,
		shadowOffset: PT.oneOf([3, 4, 5]),
		shadowOpacity: PT.number,
		shadowBlur: PT.bool,
		shadowClass: PT.string,
		disabled: PT.bool,
		// For quads with inner border line instead of solid border.
		redrawBorderClass: PT.string,
		// In cases where the CSS size is given and measuring is too slow, you can
		// pass the size in here to bypass measuring.
		knownSize: PT.shape({
			width: PT.number.isRequired,
			height: PT.number.isRequired,
			units: PT.oneOf(["px", "rem"]).isRequired,
			// Optional; saves some rerenders if provided.
			containerDims: PT.shape({
				width: PT.number.isRequired,
				height: PT.number.isRequired,
				left: PT.number.isRequired,
				top: PT.number.isRequired,
				windowWidth: PT.number.isRequired,
				windowHeight: PT.number.isRequired,
			}),
		}),
	},

	getDefaultProps: function() {
		return defaultProps;
	},

	renderWithSize: function(measure) {
		const {
			quad,
			backgroundClass,
			borderClass,
			backgroundColor,
			shadowOffset,
			shadowOpacity,
			shadowBlur,
			redrawBorderClass,
			shadowClass,
		} = this.props;
		const {width, height} = measure;
		const qv = quad(width, height);
		const realBorderWidths = computeBorderWidths(this.props, measure);

		// Slightly shrink background quad to avoid bleeding through border.
		const fullD =
			`M${qv[0]},${qv[1]}L${qv[2]},${qv[3]}` +
			`L${qv[4]},${qv[5]}L${qv[6]},${qv[7]}z`;
		const fqv = shrinkQuad(
			qv,
			realBorderWidths[0] / 3,
			realBorderWidths[1] / 3,
			realBorderWidths[2] / 3,
			realBorderWidths[3] / 3
		);
		const shrunkenFullD =
			`M${fqv[0]},${fqv[1]}L${fqv[2]},${fqv[3]}` +
			`L${fqv[4]},${fqv[5]}L${fqv[6]},${fqv[7]}z`;
		let bgEl;
		if (backgroundColor) {
			bgEl = <path fill={backgroundColor} d={shrunkenFullD} />;
		} else {
			bgEl = <path className={backgroundClass} d={shrunkenFullD} />;
		}

		const borderEls = computeBorderEls(qv, borderClass, realBorderWidths);
		const topBorderEls = redrawBorderClass
			? computeBorderEls(qv, redrawBorderClass, realBorderWidths)
			: null;

		const {svgStyle, svgViewBox} = computeSVGOverflow(
			qv,
			width,
			height,
			shadowOffset || 0,
			shadowBlur || false
		);
		let shadow, blurEl;
		if (shadowOffset || shadowOpacity || shadowBlur) {
			const shadowClassActual =
				(shadowClass ? shadowClass + " " : "") +
				styles["sh" + (shadowOffset || 3)];
			const shadowStyle = {
				opacity: shadowOpacity,
				filter: shadowBlur ? "url(#blur)" : "none",
			};
			const shadowProps = {
				d: fullD,
				style: shadowStyle,
				className: shadowClassActual,
			};
			if (!shadowClass) shadowProps.fill = "#000";
			shadow = <path {...shadowProps} />;
		}
		if (shadowBlur) {
			blurEl = (
				<filter id="blur">
					<feGaussianBlur in="SourceAlpha" stdDeviation="2" />
				</filter>
			);
		}
		const mainClass = this.props.disabled ? styles.mainDisabled : styles.main;

		return (
			<React.Fragment>
				<svg
					version="1.1"
					xmlns="http://www.w3.org/2000/svg"
					viewBox={svgViewBox}
					preserveAspectRatio="none"
					style={svgStyle}
					className={mainClass + " " + (this.props.svgClass || "")}
				>
					{shadow}
					{bgEl}
					{borderEls}
					{topBorderEls}
					<defs>{blurEl}</defs>
				</svg>
			</React.Fragment>
		);
	},

	render: function() {
		const {knownSize, containerIgnoresBorder} = this.props;
		if (knownSize) {
			const renderWithDims = containerDims => {
				const remCoeff = getRootFontSize(containerDims);
				let {width, height} = knownSize;
				if (knownSize.units === "rem") {
					width = Math.round(width * remCoeff);
					height = Math.round(height * remCoeff);
				}
				return this.renderWithSize({width, height, containerDims});
			};
			if (knownSize.containerDims) {
				return renderWithDims(knownSize.containerDims);
			} else {
				return <ContainerDims render={renderWithDims} />;
			}
		} else {
			const style = {width: "100%", height: "100%"};
			if (!containerIgnoresBorder) {
				// Width 100% and height 100% do not account for borders, so add that in.
				// In some cases we don't need this, which is why containerIgnoresBorder
				// exists.
				const borderWidths =
					this.props.borderWidths || defaultProps.borderWidths;
				const borderUnits = this.props.borderUnits || defaultProps.borderUnits;
				const borders = borderWidths.map(x => x + borderUnits);
				style.width = "calc(100% + " + borders[1] + " + " + borders[3] + ")";
				style.height = "calc(100% + " + borders[0] + " + " + borders[2] + ")";
				style.alignSelf = "center";
			}
			return (
				<MeasuredEl
					renderChild={this.renderWithSize}
					style={style}
					useAbsoluteDiv={true}
					useBoundingClientRect={this.props.useBoundingClientRect}
					skipRenderOnResize={this.props.borderUnits !== "px"}
				/>
			);
		}
	},
});
